module.exports = __webpack_public_path__ + "img/img-1345-map.21d72a9e.png";